import React from 'react'
import PropTypes from 'prop-types'
import { Switch as RouterSwitch, Redirect, withRouter } from 'react-router-dom'
import PrivateRoute from '../../hocs/PrivateRoute'
import ShipmentsList from './ShipmentsList'
import ShipmentDetail from './ShipmentDetail'
import BillOfLadingPage from './BillOfLadingPage'
import LinesPage from './LinesPage'
import PricingPage from './PricingPage'
import AccountPage from './AccountPage'
import ConversationDetail from '../DutyAssistant/Conversations/Detail'
import { TrackingConversationsList } from '../DutyAssistant/Conversations'

// The tracking section's own router. The detail is a page rather than a drawer because it is the
// target of a Telegram deep link — someone opens `/tracking/shipments/{id}` cold, on a phone, and
// it has to resolve on its own.
const TrackingRoutes = ({ match }) => (
  <RouterSwitch>
    <Redirect exact from={match.path} to={`${match.path}/shipments`} />
    <PrivateRoute exact path={`${match.path}/shipments`} component={ShipmentsList} />
    <PrivateRoute exact path={`${match.path}/shipments/:id`} component={ShipmentDetail} />
    {/* A queue of CONVERSATIONS, above `shipments/:id` in importance and separate from it: a
        bill of lading waiting for a person has no shipment yet. */}
    <PrivateRoute
      exact
      path={`${match.path}/bills-of-lading`}
      component={BillOfLadingPage}
    />
    {/* This module's WhatsApp conversations only (owner, 2026-10-29). */}
    <PrivateRoute
      exact
      path={`${match.path}/conversations`}
      component={TrackingConversationsList}
    />
    <PrivateRoute
      exact
      path={`${match.path}/conversations/:id`}
      component={ConversationDetail}
    />
    <PrivateRoute exact path={`${match.path}/lines`} component={LinesPage} />
    <PrivateRoute exact path={`${match.path}/pricing`} component={PricingPage} />
    <PrivateRoute exact path={`${match.path}/account`} component={AccountPage} />
  </RouterSwitch>
)

TrackingRoutes.propTypes = { match: PropTypes.object }

export default withRouter(TrackingRoutes)
